export default __webpack_public_path__ + "static/media/left_arrow.207b48a0.svg";